import { Component, EventEmitter, Input, Output } from '@angular/core';

export type IBtnColor = 'orange' | 'white' | 'gray' | 'red-orange';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [],
  templateUrl: 'button.component.html',
  styleUrl: 'button.component.scss'
})
export class ButtonComponent {
  @Input() controlId = 'button-component-';
  @Input() btnColor: IBtnColor = 'orange';
  @Input() text = '';
  @Input() iconClass = '';
  @Input() iconClassLast = '';
  @Input() iconLast = false;
  @Input() isDisabled = false;
  @Input() loading = false;
  @Output() clickBtn = new EventEmitter<boolean>();

  onClick(): void {
    this.clickBtn.emit(true);
  }
}
